module.exports = __webpack_public_path__ + "static/media/tshirt.f6e2095b.svg";